<template>
  <section class="aidrama-box2">
    <!-- Pixso 65:3906 part2 — 393×802@1×；rem = @1× px × 2 -->
    <div class="aidrama-box2__inner">
      <header class="aidrama-box2__head">
        <h2 class="aidrama-box2__title">
          <span class="aidrama-box2__title-text">入局AI漫剧 </span>
          <span class="aidrama-box2__title-text aidrama-box2__title-text--accent"
            >解锁多元发展机遇</span
          >
        </h2>
        <p class="aidrama-box2__sub">对接行业真实岗位需求，提升个人核心竞争力</p>
      </header>

      <div class="aidrama-box2__compare">
        <article class="aidrama-box2-card aidrama-box2-card--roles">
          <div class="aidrama-box2-card__head">
            <h3 class="aidrama-box2-card__head-title">发展方向</h3>
          </div>
          <ul class="aidrama-box2-card__roles">
            <li v-for="role in roles" :key="role" class="aidrama-box2-card__role">
              {{ role }}
            </li>
          </ul>
        </article>

        <article class="aidrama-box2-card aidrama-box2-card--salary">
          <div class="aidrama-box2-card__head aidrama-box2-card__head--salary">
            <h3 class="aidrama-box2-card__head-title">岗位薪资</h3>
          </div>
          <ul class="aidrama-box2-card__salaries">
            <li
              v-for="tier in salaryTiers"
              :key="tier.range"
              class="aidrama-box2-card__salary-tier"
            >
              <p class="aidrama-box2-card__salary-range">{{ tier.range }}</p>
              <p class="aidrama-box2-card__salary-label">{{ tier.label }}</p>
              <p class="aidrama-box2-card__salary-source">{{ tier.source }}</p>
            </li>
          </ul>
        </article>
      </div>

      <p class="aidrama-box2__disclaimer">
        *数据来自猎聘/智联/企业公开JD，仅展示市场需求，不作为收益承诺
      </p>

      <img
        class="aidrama-box2__poster"
        :src="posterImg"
        alt="什么是AI漫剧创作"
        loading="lazy"
        decoding="async"
      />

      <button type="button" class="aidrama-box2__cta" @click="handleCtaClick">
        <span class="aidrama-box2__cta-text">更多发展方向</span>
        <img class="aidrama-box2__cta-arrow" :src="btnArrow" alt="" />
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "AidramaBox2",
  data() {
    return {
      btnArrow: require("../../../assets/coursePage/aidrama/box2/btn_arrow.png"),
      posterImg: require("../../../assets/coursePage/aidrama/box2/poster.png"),
      roles: ["AI漫剧导演", "编剧", "分镜师", "剪辑师", "IP运营", "... ..."],
      salaryTiers: [
        {
          range: "6K-10K",
          label: "初级/实习岗位参考",
          source: "招聘平台2026年Q1",
        },
        {
          range: "12K-20K",
          label: "1年以上经验参考",
          source: "行业薪酬调研",
        },
        {
          range: "25K-50K",
          label: "资深/主创岗位参考",
          source: "部分游戏/影视公司JD",
        },
      ],
    };
  },
  methods: {
    handleCtaClick() {
      qimoChatClick();
      if (window.zhuge) {
        window.zhuge.track("点击_传智AI漫剧页-第2屏-更多就业情况", {
          终端: "H5",
          名称: "传智AI漫剧页-第2屏-更多就业情况",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">

.aidrama-box2 {
  width: 100%;
  box-sizing: border-box;
  background: linear-gradient(
    180deg,
    rgba(226, 254, 255, 1) 0%,
    rgba(69, 226, 255, 1) 100%
  );
}

.aidrama-box2__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 80px 40px 100px;
  box-sizing: border-box;
}

/* 65:3911 gap 6px */
.aidrama-box2__head {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;
}

.aidrama-box2__title {
  margin: 0;
  font-size: 48px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 60px;
  letter-spacing: 4px;
  text-align: center;
  white-space: nowrap;
}

.aidrama-box2__title-text {
  color: rgba(47, 52, 59, 1);
}

.aidrama-box2__title-text--accent {
  color: rgba(39, 101, 255, 1);
}

.aidrama-box2__sub {
  margin: 0;
  width: 100%;
  font-size: 22px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 4px;
  text-align: center;
  color: rgba(64, 69, 77, 1);
}

/* 标题底 → 双卡顶约 34px */
.aidrama-box2__compare {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
  gap: 36px;
  width: 100%;
  margin-top: 68px;
  box-sizing: border-box;
}

.aidrama-box2-card {
  display: flex;
  flex: 1 1 calc(50% - 18px);
  flex-direction: column;
  width: calc(50% - 18px);
  min-width: 0;
  min-height: 536px;
  box-sizing: border-box;
  border-radius: 40px;
  border: 4px solid rgba(110, 210, 255, 1);
  overflow: hidden;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.2) 0%,
    rgba(208, 255, 238, 1) 100%
  );
}

.aidrama-box2-card--salary {
  border-color: rgba(202, 173, 255, 1);
}

.aidrama-box2-card__head {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 80px;
  flex-shrink: 0;
  background: linear-gradient(
    270deg,
    rgba(47, 152, 255, 1) 0%,
    rgba(39, 101, 255, 1) 100%
  );
}

.aidrama-box2-card__head--salary {
  background: linear-gradient(
    270deg,
    rgba(168, 64, 233, 1) 0%,
    rgba(93, 85, 255, 1) 100%
  );
}

.aidrama-box2-card__head-title {
  margin: 0;
  font-size: 30px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 30px;
  text-align: center;
  color: #fff;
  white-space: nowrap;
}

.aidrama-box2-card__roles {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  margin: 0;
  padding: 40px 16px 32px;
  list-style: none;
  box-sizing: border-box;
}

.aidrama-box2-card__role {
  font-size: 28px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 28px;
  text-align: center;
  color: rgba(39, 101, 255, 1);
  white-space: nowrap;
}

/* 65:3932 — 表头 40px；三档 top 60 / 124.9 / 190.8；档内 lh 15+20+20 */
.aidrama-box2-card--salary .aidrama-box2-card__salaries {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  margin: 0;
  padding: 40px 24px 48px;
  list-style: none;
  box-sizing: border-box;
}

.aidrama-box2-card__salary-tier {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
}

.aidrama-box2-card__salary-range {
  margin: 0;
  font-size: 30px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 30px;
  text-align: center;
  color: rgba(160, 66, 235, 1);
  white-space: nowrap;
}

.aidrama-box2-card__salary-label {
  margin: 0;
  font-size: 24px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
  color: rgba(51, 51, 51, 1);
}

.aidrama-box2-card__salary-source {
  margin: 0;
  font-size: 22px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 40px;
  text-align: center;
  color: rgba(51, 51, 51, 1);
}

.aidrama-box2__disclaimer {
  margin-top: 22px;
  padding: 0 8px;
  font-size: 20px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  color: rgba(87, 108, 137, 1);
}

/* 65:3914 — 363×240 整体说明图 */
.aidrama-box2__poster {
  display: block;
  width: 100%;
  height: auto;
  margin-top: 54px;
  box-sizing: border-box;
}

/* 说明卡底 → 按钮顶 24px；65:3908 padding 20/30/20/36 */
.aidrama-box2__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-top: 48px;
  padding: 36px 60px 36px 72px;
  box-sizing: border-box;
  border: none;
  border-radius: 24px;
  box-shadow: inset 0 0 22px rgba(255, 255, 255, 1);
  background: linear-gradient(
    270deg,
    rgba(188, 117, 255, 1) 0%,
    rgba(117, 104, 255, 1) 100%
  );
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.aidrama-box2__cta-text {
  font-size: 30px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 4px;
  color: #fff;
  white-space: nowrap;
}

.aidrama-box2__cta-arrow {
  display: block;
  width: 12px;
  height: 20px;
  flex-shrink: 0;
  object-fit: contain;
  opacity: 0.4;
}
</style>
